import { DateTime } from "luxon";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import { luxonDateTimeToBackendDateOrDateTime } from "../../../../../../utils/dates/luxonDateTimeToBackendDateOrDateTime";
import type { ChangeableFieldData } from "../../../../../ChangeableFieldWidget/ChangeableFieldWidget";
import type { Price } from "../../../../../DeliveryOverview/DeliveryOverview.types";

export function convertPricesToChangeableFieldData(prices?: Array<Price>) {
  if (!prices) {
    return undefined;
  }

  return prices
    .map<ChangeableFieldData>((price) => ({
      id: price.id,
      startDate: price.first_date
        ? backendDateOrDateTimeToLuxonDateTime(price.first_date)
        : null,
      endDate: price.last_date
        ? backendDateOrDateTimeToLuxonDateTime(price.last_date)
        : null,
      value: price.value
    }))
    .sort((a, b) => {
      if (a.startDate === null && b.startDate === null) {
        return 0;
      } else if (a.startDate === null) {
        return -1;
      } else if (b.startDate === null) {
        return 1;
      } else if (a.startDate < b.startDate) {
        return -1;
      } else if (b.startDate < a.startDate) {
        return 1;
      }

      return 0;
    });
}

export function convertChangeableFieldDataToPrices(
  values: Array<ChangeableFieldData<number>>
) {
  return values.flatMap<Price>((value) => {
    if (value.value === null) return [];
    return [
      {
        id: value.id,
        value: value.value,
        first_date: value.startDate
          ? luxonDateTimeToBackendDateOrDateTime(value.startDate)
          : null,
        last_date: value.endDate
          ? luxonDateTimeToBackendDateOrDateTime(value.endDate)
          : null
      }
    ];
  });
}

export function getCurrentPrice(prices: Array<Price>) {
  const now = DateTime.now();

  return prices.find((price) => {
    const firstDate = price.first_date
      ? backendDateOrDateTimeToLuxonDateTime(price.first_date)
      : null;
    const lastDate = price.last_date
      ? backendDateOrDateTimeToLuxonDateTime(price.last_date)
      : null;

    const firstDateInRange = !firstDate || firstDate <= now;
    const lastDateInRange = !lastDate || now <= lastDate;

    return firstDateInRange && lastDateInRange;
  });
}

export function getEarliestDate(noIdObjects: Array<Price>) {
  return noIdObjects.reduce((prev, curr) => {
    if (prev.first_date === null) {
      return prev;
    } else if (curr.first_date === null) {
      return curr;
    }

    const prevDate = backendDateOrDateTimeToLuxonDateTime(prev.first_date);
    const currDate = backendDateOrDateTimeToLuxonDateTime(curr.first_date);

    return prevDate < currDate ? prev : curr;
  });
}
